import createLog from 'localstorage-logger';
import { ILog } from 'localstorage-logger/build/ILog';
import { IBookkeepingInfo } from 'localstorage-logger/build/queue/IBookkeepingInfo';
/**
 * This enum defines the type of a debug log message.
 */
export enum LogMessageType {
    info,
    error,
    fatal,
    success
}

/**
 * This class contains the information and text of a debug log message.
 */
export class LogMessage {
    type: LogMessageType;
    text: string;

    constructor(type: LogMessageType, text: string) {
        this.type = type;
        this.text = text;
    }
}

/**
 * This class handles the logging facility and offers logging storage.
 */
export class DefaultLogger {
    protected logBuffer: ILog;

    constructor() {
        this.reset();
    }

    /**
     * Forces the logger to reread it's persisted state.
     */
    public reset() {
        this.logBuffer = createLog({
            logName: 'addin-logger',
            maxLogSizeInBytes: 500 * 1024 // 500KB
        }) as ILog;
    }

    /**
     * This callback is invoked every time the add-in logs a message.
     */
    public logMessage(logMessage: LogMessage) {
        this.logMessageWithType(logMessage.type, logMessage.text);
    }

    /**
     * This callback is invoked every time the add-in logs a message.
     */
    public logMessageWithType(type: LogMessageType, text: string) {
        switch (type) {
            default:
            case LogMessageType.info:
                this.logBuffer.info(text);
                break;

            case LogMessageType.error:
                this.logBuffer.error(text);
                break;
        }
    }

    /**
     * Returns all the formatted log messages inside an array
     */
    public getAllLogMessages(): string[] {
        return this.logBuffer.exportToArray();
    }

    /**
     * Erases all logs
     */
    public eraseLogs(): void {
        const loggerInfo = JSON.parse(localStorage.getItem('addin-logger')) as IBookkeepingInfo;

        for (let idx = loggerInfo.startIndex; idx !== loggerInfo.nextFreeIndex; idx = (idx + 1) % 9007199254740991) {
            localStorage.removeItem(`addin-logger-item-${idx}`);
        }

        localStorage.removeItem('addin-logger');
        this.reset();
    }

}